<template>
    <div class="billing">
        <div v-if="isLoaded" class="row">
            <template v-if="billing.length > 0">
                <div class="table-responsive">
                    <table class="table table-hover" v-for="(billingYear,key) in billing" :key="key">
                        <thead class="thead-dark">
                            <tr>
                                <th colspan="3">{{ billingYear.year }}</th>
                            </tr>
                        </thead>
                        <template v-for="(billingMonth,rkey) in billingYear.months">
                            <tr class="table-secondary" :key="rkey">
                                <td>
                                    {{ $t("month." + billingMonth.month) | capitalize-first }}
                                </td>
                                <td>
                                    <a class="billing-rows-toggle" @click.prevent="billingMonth.visible = !billingMonth.visible">
                                        {{ $t("manager.company.billing.rows") }}
                                        {{ billingMonth.events.length }}
                                        <font-awesome-icon v-if="!billingMonth.visible" icon="caret-right" />
                                        <font-awesome-icon v-else icon="caret-down" />
                                    </a>
                                </td>
                                <td class="text-right">
                                    {{ $t("manager.company.billing.total") }}
                                    {{ billingAmount(billingMonth.events.length) | round-two-decimals | decimal-comma }} &euro;
                                </td>
                            </tr>
                            <template v-if="billingMonth.visible">
                                <template v-for="(billingEvent,ekey) in billingMonth.events" >
                                    <tr :key="ekey">
                                        <td colspan="3">
                                            <router-link :to="{ name: 'offer', params: { id: billingEvent.hash }}">{{ billingEvent.offer }}</router-link>
                                            <span class="float-right">{{ $d(new Date(billingEvent.created), 'long', 'fi-FI') }}</span>
                                        </td>
                                    </tr>
                                </template>
                            </template>
                        </template>
                    </table>

                    <p class="mt-5">{{ $t("manager.company.billing.info") }}:</p>
                    <table class="table">
                        <thead class="thead-dark">
                            <tr>
                                <th>{{ $t("manager.company.billing.rows") | capitalize-first }}</th>
                                <th>{{ $t("manager.company.billing.pricePerRow") }}</th>
                            </tr>
                        </thead>
                        <tr>
                            <td>1-100</td>
                            <td>0,80 &euro;</td>
                        </tr>
                        <tr>
                            <td>101-500</td>
                            <td>0,60 &euro;</td>
                        </tr>
                        <tr>
                            <td>500+</td>
                            <td>0,40 &euro;</td>
                        </tr>
                    </table>
                </div>
            </template>
            <template v-else>
                <div class="alert alert-warning">
                    {{ $t("noRows") }}
                </div>
            </template>
        </div>
        <div v-else class="offer m-3 p-3 border rounded">
            <div class="text-center">
                <font-awesome-icon icon="spinner" pulse />
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BillingList',
  data () {
    return {
      isLoaded: false,
      billing: {}
    }
  },
  props: {
    backendId: String
  },
  methods: {
    loadBillingList: function () {
      let me = this
      axios.get(me.$store.getters.urlPath + 'services/manager/getBillingList.php?backendId=' + this.backendId, {
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
        .then(function (response) {
          me.billing = response.data
          me.isLoaded = true
        })
        .catch(function (error) {
          // eslint-disable-next-line
          console.log(error)
        })
    },
    billingAmount: function (events) {
      if (events <= 100) {
        return events * 0.8
      } else if (events <= 500) {
        return events * 0.6
      } else {
        return events * 0.4
      }
    }
  },
  mounted () {
    this.loadBillingList()
  }
}
</script>

<style lang="scss">
.billing {
    width: 100%;

    .billing-rows-toggle:hover,
    .list-group-item:hover {
        cursor: pointer;
    }
}
</style>
